<!-- <shared-loader-general [loading]="loading"></shared-loader-general> -->

<div
  class="fixed inset-0 z-50 flex items-center justify-center"
  aria-labelledby="modal-title"
  role="dialog"
  aria-modal="true"
>
  <div
    class="flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center w-full"
  >
    <!-- Background overlay -->
    <div
      class="fixed inset-0 bg-gray-950/60 bg-opacity-85 transition-opacity"
      (click)="closeModal()"
    ></div>

    <!-- Modal panel -->
    <div
      class="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-5xl sm:w-full relative max-h-[90vh]"
    >
      <div
        class="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4 overflow-y-auto max-h-[calc(90vh-120px)]"
      >
        <div class="sm:flex sm:items-start">
          <!-- SE MUESTRA ABAJO CUANDO ES WEB -->
          <div class="flex sm:hidden justify-between items-start">
            <div>
              <h3 class="text-2xl leading-6 font-bold text-gray-900 mb-2">
                {{ product.pd_name }}
              </h3>
              <div class="text-sm text-gray-500">
                {{ product.name_restaurant }}
              </div>
            </div>
            <button
              class="text-gray-400 hover:text-gray-500"
              (click)="closeModal()"
            >
              <svg
                class="h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>
          </div>
          <!-- Product Image con badges y una sola miniatura -->
          <div class="relative w-full sm:w-64">
            <div class="absolute top-2 left-2 flex gap-2">
              @if (isLoadingProduct) {
                <ngx-skeleton-loader
                  [theme]="{
                    width: '80px',
                    height: '20px',
                    'border-radius': '999px'
                  }"
                ></ngx-skeleton-loader>
                <ngx-skeleton-loader
                  [theme]="{
                    width: '120px',
                    height: '20px',
                    'border-radius': '999px'
                  }"
                ></ngx-skeleton-loader>
              } @else {
              <span
                class="inline-flex items-center px-2 py-0.5 rounded-full text-[11px] font-semibold bg-orange-500 text-white shadow"
              >
                {{ product.category_name || product.categoryName! }}
              </span>
              <span
                class="inline-flex items-center px-2 py-0.5 rounded-full text-[11px] font-semibold bg-orange-500 text-white shadow"
              >
                {{ product.ps_name || product.subcategoryName! }}
              </span>
              }
            </div>
            <image-view-product
              [imageUrl]="product.pd_image"
              [alt]="product.pd_name"
              [loading]="isLoadingProduct"
              class="w-full sm:w-64 h-64 object-cover rounded-lg"
            />
            <!-- Miniatura única bajo la imagen principal -->
            <div class="mt-3 flex items-center gap-2">
              @if (isLoadingProduct) {
                <ngx-skeleton-loader
                  [theme]="{
                    width: '64px',
                    height: '64px',
                    'border-radius': '8px'
                  }"
                ></ngx-skeleton-loader>
              }
            </div>
          </div>

          <!-- Product Details -->
          <div class="mt-3 sm:mt-0 sm:ml-4 sm:text-left flex-grow">
            <!-- SE MUESTRA ARRIBA CUANDO ES MOVIL -->
            <div class="hidden sm:flex justify-between items-start">
              <div>
                <h3 class="text-xl leading-6 font-bold text-gray-900 mb-2">
                  {{ product.pd_name }}
                </h3>
                <div class="text-sm text-gray-500">
                  {{ product.name_restaurant }}
                </div>
              </div>
              <button
                class="cursor-pointer text-gray-400 hover:text-gray-500 flex justify-end"
                (click)="closeModal()"
              >
                <svg
                  class="h-6 w-6"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              </button>
            </div>

            <div class="mt-2 sm:mt-4">
              <!-- Description -->
              @if (isLoadingProduct) {
              <div class="space-y-2 mb-2 sm:mb-4">
                <ngx-skeleton-loader
                  [theme]="{
                    width: '70%',
                    height: '24px',
                    'border-radius': '6px'
                  }"
                ></ngx-skeleton-loader>
                <ngx-skeleton-loader
                  [theme]="{
                    width: '90%',
                    height: '14px',
                    'border-radius': '6px'
                  }"
                ></ngx-skeleton-loader>
                <ngx-skeleton-loader
                  [theme]="{
                    width: '85%',
                    height: '14px',
                    'border-radius': '6px'
                  }"
                ></ngx-skeleton-loader>
              </div>
              } @else {
              <p class="text-gray-700 text-base mb-2 sm:mb-4">
                {{ product.pd_description }}
              </p>
              }

              <!-- Stock Status -->
              <div class="mb-2 sm:mb-3">
                <span
                  class="text-sm"
                  [class.text-green-600]="product.pd_is_stock != 1"
                  [class.text-red-600]="product.pd_is_stock == 0"
                >
                  {{
                  product.pd_is_stock != 1
                  ? `Stock disponible: ${product.pd_quantity}`
                  : " Disponible"
                  }}
                </span>
              </div>
              <!-- Precio unitario estilo tarjeta -->
              <div class="mb-2 sm:mb-4">
                <div
                  class="flex items-center justify-between bg-orange-50 border border-orange-100 rounded-lg px-4 py-3"
                >
                  <span class="text-sm text-gray-700">Precio unitario</span>
                  <span class="font-bold text-orange-600 sm:text-2xl text-lg"
                    >${{ product.pd_unit_price }}</span
                  >
                </div>
              </div>
              <div class="flex items-center justify-between mb-2 sm:mb-4">
                <span class="font-bold text-yellow-500 sm:text-2xl text-lg">
                  Total: ${{ total.toFixed(2) }}
                </span>
              </div>

              <!-- Cantidad centrada con botones a los lados -->
              <div class="mb-2 sm:mb-4">
                <div class="flex flex-col items-center">
                  <span class="text-gray-700 mb-1">Cantidad</span>
                  <div class="flex items-center gap-6 mt-1 justify-center">
                    <button
                      #btnMinus
                      class="cursor-pointer w-10 h-10 flex items-center justify-center rounded-full border border-gray-300 text-gray-700 hover:border-orange-400 hover:text-orange-600 transition"
                      (click)="
                        decrementQuantity(btnMinus, qtyValue, qtyContainer)
                      "
                    >
                      −
                    </button>
                    <span
                      #qtyValue
                      class="text-2xl font-semibold text-gray-900"
                      >{{ quanityProduct }}</span
                    >
                    <button
                      #btnPlus
                      class="cursor-pointer w-10 h-10 flex items-center justify-center rounded-full border border-gray-300 text-gray-700 hover:border-orange-400 hover:text-orange-600 transition"
                      (click)="
                        incrementQuantity(btnPlus, qtyValue, qtyContainer)
                      "
                    >
                      +
                    </button>
                    <!-- Contenedor invisible solo para compatibilidad de referencia -->
                    <div #qtyContainer class="hidden"></div>
                  </div>
                </div>
              </div>
              <!-- Complementos y Variaciones -->
              @defer (on immediate) {
              <modal-view-complements-variations
                [variations]="variations"
                [complements]="complements"
                [loading]="isLoadingComplementsVariations"
                (selectionChanged)="calculateTotal()"
              >
              </modal-view-complements-variations>
              }

              <!-- Error Message -->
              @if (errorMessages) {
              <div class="mt-2">
                <p
                  class="text-red-600 text-sm font-medium px-2 py-1 rounded-md bg-red-50 border border-red-200"
                >
                  {{ errorMessages }}
                </p>
              </div>
              }
            </div>
          </div>
        </div>
      </div>
      @if(isOpen()){
      <div class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
        @if (isLoggedIn) {
        <button
          type="button"
          [disabled]="
            product.pd_quantity === '0' ||
            product.isOpen === '0' ||
            isAddingToCart ||
            quanityProduct <= 0
          "
          [class.opacity-50]="
            product.pd_quantity === '0' ||
            product.isOpen === '0' ||
            isAddingToCart ||
            quanityProduct <= 0
          "
          class="cursor-pointer w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-yellow-500 text-base font-medium text-white hover:bg-yellow-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-orange-500 sm:ml-3 sm:w-auto sm:text-sm"
          #addBtn
          (click)="addToCart(product, addBtn)"
        >
          @if (isAddingToCart) {
          <svg
            class="animate-spin -ml-1 mr-3 h-5 w-5 text-white"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
          >
            <circle
              class="opacity-25"
              cx="12"
              cy="12"
              r="10"
              stroke="currentColor"
              stroke-width="4"
            ></circle>
            <path
              class="opacity-75"
              fill="currentColor"
              d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
            ></path>
          </svg>
          } @if (!isAddingToCart) {
          <i class="fa-solid fa-cart-shopping mr-2"></i>
          }
          {{ isAddingToCart ? "Añadiendo..." : "Añadir" }}
        </button>
        } @else {
        <button
          type="button"
          (click)="navigateToLogin()"
          class="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-yellow-500 text-base font-medium text-white hover:bg-yellow-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-yellow-500 sm:ml-3 sm:w-auto sm:text-sm"
        >
          Iniciar Sesión
        </button>
        }
        <button
          type="button"
          class="cursor-pointer mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-yellow-500 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"
          (click)="closeModal()"
        >
          Cancelar
        </button>
      </div>
      } @else {
      <div
        class="bg-gray-50 px-4 py-6 flex flex-col items-center justify-center space-y-3 rounded-lg border border-gray-200 m-4"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="h-12 w-12 text-red-500"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
          />
        </svg>
        <p class="text-lg font-medium text-gray-800 text-center">
          Este establecimiento se encuentra cerrado
        </p>
        <p class="text-sm text-gray-500 text-center">
          Por favor, vuelve más tarde
        </p>
      </div>
      }
    </div>
  </div>
</div>
